import { type FC } from "react";

import type { CoordinateList } from "@/graphql.ts";
import { ENTITY_TYPE } from "@/settings/settings.js";

import { SmartLink } from "../../SmartLink.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const CoordinateListNameCell: FC<IAgGridCellProps> = (props) => {
  const { value, data } = props;

  const list: CoordinateList = data;

  if (list.organism == undefined) {
    return <TableCell>{value}</TableCell>;
  }

  return (
    <TableCell>
      <SmartLink
        to={`/${ENTITY_TYPE.ORGANISM}/${list.organism.id}/genome?add_tracks=${ENTITY_TYPE.COORDINATE}&coordLists=${list.id}&showGrid=true`}
        tooltip={value}
      >
        {value}
      </SmartLink>
    </TableCell>
  );
};

export default CoordinateListNameCell;
